module.exports = __webpack_public_path__ + "img/cover5.a952c3fb.jpg";